"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractTemplateRoutes = void 0;
var ContractTemplateRoutes;
(function (ContractTemplateRoutes) {
    ContractTemplateRoutes["BasePrefix"] = "contract-templates";
    ContractTemplateRoutes["ById"] = ":contractTemplateId";
    ContractTemplateRoutes["All"] = "all";
})(ContractTemplateRoutes = exports.ContractTemplateRoutes || (exports.ContractTemplateRoutes = {}));
